import React, { useEffect, useState } from "react";
import axios from "axios";
import { Bar } from "react-chartjs-2";
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from "chart.js";

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const DepartmentProjectBarChart = () => {
    const [chartData, setChartData] = useState(null);
    const [maxCount, setMaxCount] = useState(0);
    const [totalCount, setTotalCount] = useState(0);
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");

    const fetchData = async (startDate, endDate) => {
        try {
            const params = {};
            if (startDate) params.startDate = startDate;
            if (endDate) params.endDate = endDate;

            const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/projects/department-count`, { params });
            
            if (response.data.length === 0) {
                setChartData(null);
                setTotalCount(0);
                return;
            }

            const labels = response.data.map((dept) => dept.dept_name);
            const values = response.data.map((dept) => dept.project_count);
            const total = values.reduce((sum, val) => sum + val, 0);

            setChartData({
                labels,
                datasets: [
                    {
                        label: "Project Count",
                        data: values,
                        backgroundColor: [
                           // "#2A9D8F", "#457B9D", "#F4A261", "#8D6AB8", "#F77F00",
                            //"#6D597A", "#83C5BE", "#B56576", "#264653", "#5E60CE",
                            //"#FF6F61", "#FFD700", "#00B4D8", "#D9BF77", "#FF3D7F",
                           // "#D4A5A5","#FF3D7F", // Hot Pink  
                           //   "#D4A5A5"

                          // "#2A9D8F", // Teal Green  
                        "#457B9D", // Deep Blue  
                       // "#EB5A06",
                       "#C04BA7",
                           //"#F4A261", // Warm Orange  
                           "#8D6AB8", // Muted Purple  
                           "#F77F00", // Bright Amber  
                          //"#6D597A", // Elegant Plum  
                          "#83C5BE", // Light Aqua  
                           //"#B56576", // Vintage Rose  
                         //  "#264653", // Dark Cyan  
                           "#5E60CE", 
                           "#85FF66",
                           //"#36A2EB", // Vivid Indigo  
                            // New colors
                        // "#FF6F61", // Coral Red  
                          "#FFD700", // Golden Yellow  
                          "#00B4D8", // Vivid Turquoise  
                          "#D9BF77", // Mustard Yellow  
                          // Soft Beige  
                         "#FF3D7F", // Hot Pink  
                         "#D4A5A5"
                        ],
                        borderColor: ["#FF6384", "#36A2EB", "#FFCE56", "#4BC0C0", "#9966FF", "#FF9F40"],
                        barThickness: 40,
                    },
                ],
            });
            setMaxCount(Math.max(...values) + 5);
            setTotalCount(total);
        } catch (error) {
            console.error("Error fetching data:", error);
            setChartData(null);
        }
    };

    useEffect(() => {
        fetchData(startDate, endDate);
    }, [startDate, endDate]);

    const handleFilter = () => {
        fetchData(startDate, endDate);
    };

    const handleReset = () => {
        setStartDate("");
        setEndDate("");
        fetchData("", "");
    };

    return (
        <div style={{ width: "100%", maxWidth: "1200px", height: "400px", margin: "auto" }}>

           

            <div style={{ marginBottom: "10px", display: "flex", gap: "10px", alignItems: "center" }}>
                <label>Start Date:</label>
                <input type="date" value={startDate} onChange={(e) => setStartDate(e.target.value)} />
                <label>End Date:</label>
                <input type="date" value={endDate} onChange={(e) => setEndDate(e.target.value)} />
                <button onClick={handleFilter}>Filter</button>
                <button onClick={handleReset}>Reset</button>
            </div>
            <h4 style={{ fontWeight: 'bold', fontSize: '14px', color: '#6c757d' }}>
    Total Project Count: {totalCount}
</h4>

            {chartData ? (
                <Bar
                    data={chartData}
                    options={{
                        responsive: true,
                        maintainAspectRatio: false,
                        scales: { y: { beginAtZero: true, max: maxCount } },
                        plugins: { tooltip: { enabled: true } },
                    }}
                    plugins={[
                        {
                            id: "valueInsideBar",
                            afterDatasetsDraw: (chart) => {
                                const { ctx } = chart;
                                chart.data.datasets.forEach((dataset, i) => {
                                    const meta = chart.getDatasetMeta(i);
                                    meta.data.forEach((bar, index) => {
                                        const value = dataset.data[index];
                                        ctx.fillStyle = "#fff";
                                        ctx.font = "12px Arial";
                                        ctx.textAlign = "center";
                                        ctx.textBaseline = "middle";
                                        const positionX = bar.x;
                                        const positionY = bar.y + bar.height / 2;
                                        ctx.fillText(value, positionX, positionY);
                                    });
                                });
                            },
                        },
                    ]}
                />
            ) : (
                <p style={{ textAlign: "center", fontSize: "18px", color: "gray" }}>
                    No data available for the selected date range.
                </p>
            )}
        </div>
        
    );
};

export default DepartmentProjectBarChart;
